import styled from 'styled-components';
import Link from 'components/common/link/link';

const BlueLink = styled(Link)<{ inheritFont?: boolean }>`
  color: ${props => props.theme.colors.siteBlue};
  text-decoration: underline;
  font-family: ${props => (props.inheritFont ? 'inherit' : props.theme.fonts.montserratSemiBold)};
  font-size: ${props => (props.inheritFont ? 'inherit' : '1.2rem')};
  &:hover,
  &:focus {
    color: ${props => props.theme.colors.hoverBackgroundSiteBlue};
    text-decoration: underline;
  }
`;

export default BlueLink;
